import React from "react";
import { LogOut, MoonStar, Repeat } from "lucide-react";

const pains = [
  {
    icon: LogOut,
    title: "Bezoekers haken af",
    text:
      "Mensen verlaten uw website wanneer ze niet snel genoeg vinden wat ze zoeken.",
  },
  {
    icon: MoonStar,
    title: "Vragen blijven liggen",
    text: "Buiten kantooruren is er vaak niemand om bezoekers direct te helpen.",
  },
  {
    icon: Repeat,
    title: "Uw team verliest tijd",
    text:
      "Dezelfde vragen komen steeds opnieuw binnen via mail, telefoon of chat.",
  },
];

export const PainSection = () => {
  return (
    <section id="waarom" className="relative py-16 md:py-20">
      <div className="absolute inset-0 -z-10 pointer-events-none">
        <div
          className="absolute top-10 left-1/2 -translate-x-1/2 h-[360px] w-[760px] blur-3xl opacity-15"
          style={{ background: "radial-gradient(ellipse, rgba(0,239,255,0.3), transparent 70%)" }}
        />
      </div>

      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <span className="text-[11px] uppercase tracking-[0.22em] font-mono-display text-[#00FFB7]">
            Het probleem
          </span>
          <h2 className="mt-4 font-display font-semibold text-white text-3xl md:text-[42px] tracking-tight leading-[1.1]">
            Uw website krijgt bezoekers.{" "}
            <span className="text-gradient-neon">Maar hoeveel worden er aanvragen?</span>
          </h2>
          <p className="mt-5 text-[#A7A7A7] text-base md:text-[17px] leading-relaxed">
            Veel bezoekers hebben vragen, twijfels of bezwaren voordat ze contact
            opnemen. Als ze niet snel duidelijkheid krijgen, klikken ze weg of komen
            ze later niet meer terug.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {pains.map((p, i) => {
            const Icon = p.icon;
            return (
              <div
                key={i}
                data-testid={`pain-card-${i}`}
                className="group relative glass rounded-2xl p-5 md:p-6 hover:border-[#00EFFF]/25 transition-colors"
              >
                <div className="flex items-start gap-4">
                  <div className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-white/10 bg-white/[0.03] shrink-0">
                    <Icon className="h-4.5 w-4.5 text-[#A8FF00]" />
                  </div>
                  <div>
                    <h3 className="font-display font-semibold text-white text-lg leading-snug">
                      {p.title}
                    </h3>
                    <p className="mt-1.5 text-[#A7A7A7] text-sm leading-relaxed">
                      {p.text}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PainSection;
